
import { Card } from "@/components/ui/card";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface MonthlyData {
  name: string;
  revenue: number;
  pending_revenue: number;
}

interface RevenueChartProps {
  data: MonthlyData[];
}

const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
  }).format(value);
};

export const RevenueChart = ({ data }: RevenueChartProps) => {
  return (
    <Card className="p-6 mb-8">
      <h3 className="text-lg font-semibold mb-4">Monthly Revenue</h3>
      <div className="h-[400px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart 
            data={data}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis 
              tickFormatter={(value) => formatCurrency(value)}
            />
            <Tooltip 
              formatter={(value: number) => formatCurrency(value)}
              labelFormatter={(label) => `Month: ${label}`}
            />
            <Legend />
            <Line 
              type="monotone" 
              dataKey="revenue" 
              name="Revenue" 
              stroke="#008169" 
              strokeWidth={2}
              activeDot={{ r: 8 }}
              dot={{ strokeWidth: 2 }}
              isAnimationActive={false}
            />
            <Line 
              type="monotone" 
              dataKey="pending_revenue" 
              name="Pending Revenue" 
              stroke="#FFA500" 
              strokeWidth={2}
              activeDot={{ r: 8 }}
              dot={{ strokeWidth: 2 }}
              isAnimationActive={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};
